import { Alert, Snackbar } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_NOTICE_STATE_KEY } from '../hooks/useOpenNotification';

/** Shows a one-off message passed in router state (e.g. "this student no
 * longer exists" after a notification click fell back to a list page),
 * then clears it so a refresh or Back doesn't show it again. */
export const RouteNotice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const notice = (location.state as Record<string, unknown> | null)?.[ROUTE_NOTICE_STATE_KEY];
  if (typeof notice !== 'string' || !notice) return null;

  const dismiss = () =>
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });

  return (
    <Snackbar
      key={location.key}
      open
      autoHideDuration={8000}
      onClose={(_e, reason) => reason !== 'clickaway' && dismiss()}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="info" variant="filled" onClose={dismiss} sx={{ maxWidth: 520 }}>
        {notice}
      </Alert>
    </Snackbar>
  );
};
